export default __webpack_public_path__ + "static/media/global-api-analitics.96589900.svg";